import { questionContainer } from '../questionContainer/index'
import { questionEdit } from './questionEdit'
import QuestionEditFormLookups from './questionEditFormComponents'

const QuestionEditComponentLookup = questionContainer(QuestionEditFormLookups)

export { questionEdit, QuestionEditComponentLookup }
